import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { permissionStore } from "@/hooks";
import { DetailsPanel } from "@/components/common";
import {
  ArtifactContent,
  ArtifactViews,
  ArtifactTraces,
  ArtifactContext,
} from "@/components/artifact/display";
import {
  ArtifactButtons,
  ArtifactComments,
  ArtifactHealth,
} from "@/components/artifact/save";

/**
 * Displays artifact information.
 */
const __default__ = {
  name: "ArtifactPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), { panel: "displayArtifact" }, {
    actions: _withCtx(() => [
      _createVNode(_unref(ArtifactButtons))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ArtifactContent)),
      (_unref(permissionStore).isNASA)
        ? (_openBlock(), _createBlock(_unref(ArtifactContext), { key: 0 }))
        : (_openBlock(), _createBlock(_unref(ArtifactTraces), { key: 1 })),
      _createVNode(_unref(ArtifactComments)),
      _createVNode(_unref(ArtifactHealth)),
      _createVNode(_unref(ArtifactViews))
    ]),
    _: 1
  }))
}
}

})